import React from "react";

export default function ImageBlock({ block }) {
  if (!block) return null;

  const { props } = block;

  const maxWidth = `${props.maxWidth}px`

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "1rem",
      }}
    >
      {props.imgUrl && (
        <img
          src={props.imgUrl}
          alt=""
          aria-hidden="true"
          style={{ display: "block", maxWidth: maxWidth, marginBottom: '1em' }}
        />
      )}
      {props.icon && (
        <i className={`bi ${props.icon}`} style={{fontSize: '4rem', color: '#E70880'}}></i>
      )}
    </div>
  );
}
